import React from 'react';


const LanguageSelector = ({ currentLanguage, onLanguageChange }) => {
  const languages = [
    { code: 'fr', label: 'Français', flag: '🇫🇷' },
    { code: 'ar', label: 'العربية', flag: '🇲🇦' }
  ];

  return (
    <div className="flex items-center gap-2 mb-6">
      {languages?.map((lang) => (
        <button
          key={lang?.code}
          onClick={() => onLanguageChange(lang?.code)}
          className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-all duration-250 ${
            currentLanguage === lang?.code
              ? 'bg-primary text-primary-foreground shadow-elevation-sm'
              : 'bg-muted text-muted-foreground hover:bg-muted/80'
          }`}
          aria-label={`Switch to ${lang?.label}`}
        >
          <span className="text-lg">{lang?.flag}</span>
          <span className="text-sm font-medium">{lang?.label}</span>
        </button>
      ))}
    </div>
  );
};

export default LanguageSelector;